import Promotion from 'src/Models/Promotions/Model'
import * as TYPES from '../../types'

export default {
  [TYPES.SET_CURRENT_PROMOTION](state, promotion) {
    state.current = new Promotion(promotion)
  },
}
